import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavController, PopoverController } from '@ionic/angular';
import { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, TypeEnum } from '@wlp/ui-bs-account-payment-favorite';
import { BilletService, ChargingService } from '@wlp/ui-bs-cashin';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import * as moment from 'moment';
import { of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';
import { PopoverFavoritesComponent } from 'src/app/views/themes/sentinel/modals/popover-favorites/popover-favorites.component';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'ui-t-billet-emit-individual',
  templateUrl: './billet-emit-individual.page.html',
  styleUrls: ['./billet-emit-individual.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class CharginBilletEmitIndividual implements OnInit {
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  public billetChargingForm: FormGroup;
  public formPersonalAddress: FormGroup;
  public switchFavorites: any = 'new';
  public errorMessages: any;
  public billetChargingValue: any;

  userProfile: UserInfoProfile;
  responseTransfer: any;
  listReceiptsShow: any;

  selectedFavorite: boolean;
  isAdress: boolean;
  textButton: string;

  formErrorMessages: any;
  listUf: Array<any>;
  favoriteId: any;
  favorite: any;
  isCreatingFavorite: any = false;
  drawerData: any;

  constructor(
    private navCtrl: NavController,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    protected userInfoService: UserInfoService,
    public service: ChargingService,
    private serviceBillet: BilletService,
    public pipeFilter: FavoritesDataFilterPipe,
    public popoverController: PopoverController,
    private loadingService: LoadingService,
    private storage: Storage,
    public router: Router,
  ) {
   // console.log('## CharginBilletEmitIndividual.contructor')
    moment.locale('pt-br');
  }

  ngOnInit(): void {
   // console.log('## CharginBilletEmitIndividual.ngOnInit')
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);


    this.loadUser();
    this.resetForms();

    
    this.isAdress = false;
    this.textButton = 'Continuar';
    this.listUf = this.accountPaymentFavoriteService.getUf();

  }

  searchPostalCode(data: any) {
    this.accountPaymentFavoriteService.searchPostaCode(data.target.value);
  }

  getAllFavorites() {
    this.accountPaymentFavoriteService
      .getAllFavoritesType(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, TypeEnum.BILLET)
      .pipe(
        tap((data) => {
          this.responseTransfer = data;
          this.listReceiptsShow = data;
          this.listReceiptsShow = this.accountPaymentFavoriteService.sortFavoritesListByName(this.listReceiptsShow);
        }),
        retry(2),
        catchError((_) => {
          return of(null);
        })
      )
      .subscribe();
  }

  deleteFavorite(favorite) {
    this.loadingService.show();
    this.accountPaymentFavoriteService
      .deleteFavorite(favorite)
      .pipe(
        tap((data) => {
          if (data.status) {
            // this.statusTransaction('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS_FAVORITES_EXCLUDE', true);
            this.getAllFavorites();
          } else {
            // this.statusTransaction('failed', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_FAVORITES', true);
          }
          this.loadingService.hide();
        }),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
  }

  optionsFavorites(favorite) {
    this.favoriteId = favorite.id;
    this.favorite = favorite;

    this.billetChargingForm.setValue({
      document: favorite.document,
      nameComplete: favorite.name,
      email: favorite.email,
      dateDue: '',
      orderNumber: '',
      billetBodyObservations: '',
      descripiton: '',
      billetValue: '',
    });


    this.formPersonalAddress.setValue({
      document: favorite.document,
      name: favorite.document,
      email: favorite.email,
      postalCode: favorite.zipCode,
      address: favorite.address,
      numberAddress: favorite.addressNumber,
      complementAddress: favorite.addressComplement,
      neighborhood: favorite.neighborhood,
      cityAddress: favorite.city,
      uf: favorite.state,
      country: favorite.country,
    });

    this.textButton = '';
    this.selectedFavorite = true;
    this.switchFavorites = 'new';
  }

 
  public filterReceipt(value) {
    if (value !== '') {
      this.listReceiptsShow = this.pipeFilter.transform(this.responseTransfer, value);
      return;
    } else {
    }
  }

  segmentChanged(favorite) {
    this.getAllFavorites();
    this.switchFavorites = favorite;
    if (this.isAdress) {
      this.isAdress = false;
    }
  }

  resetForms() {
    this.billetChargingForm = this.service.createFormEmitBillet();
    this.errorMessages = this.service.getErrorMessages();
    this.formPersonalAddress = this.accountPaymentFavoriteService.createFormFavoriteCharging();
    this.formErrorMessages = this.accountPaymentFavoriteService.getFormMessageError();
  }

  async loadUser() {
   // console.log('-- loadUser')
    try {
      const user = await this.userInfoService.getInfoProfile();
      this.userProfile = user;
      this.getTaxBillet(user.uuidWhiteLabel, user.uuidAccount);
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  private async getTaxBillet(uuidWhiteLabel: string, uuidAccount: string) {
    const res = await this.serviceBillet.getBilletCreateTax(uuidWhiteLabel, uuidAccount, '701');
    if (res) {
      this.billetChargingValue = res.value;
    }
  }

  confirmEmit() {
    this.nextPage();
  }
  public validForm() {

    const addressRequiredFields = ['postalCode', 'address', 'numberAddress', 'neighborhood', 'cityAddress', 'uf'] ;
    const payerRequiredFields = ['document', 'nameComplete', 'email'] ;
    let isValid = true;
    const formIsValid = (form: FormGroup, fields: string[]): boolean => {
      for (var field of fields) {
        if (!form.controls[field].valid) {
          isValid = false;
        }
      }
      return isValid;
    };
    const formAddressIsValid = formIsValid(this.formPersonalAddress, addressRequiredFields);
    const formPayerIsValid = formIsValid(this.billetChargingForm, payerRequiredFields);

    if (!formAddressIsValid || !formPayerIsValid) return;
    return isValid;
  }

  saveFavorite() {
    if (this.favorite) {
      let prepare: AccountPaymentFavoriteDTO;

      prepare = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        name: this.billetChargingForm.controls.nameComplete.value,
        document: this.billetChargingForm.controls.document.value,
        email: this.billetChargingForm.controls.email.value,
        codeBank: '',
        bankName: '',
        accountNumber: '',
        agencyNumber: '',
        typeAccount: '',
        zipCode: this.formPersonalAddress.controls.postalCode.value,
        address: this.formPersonalAddress.controls.address.value,
        addressNumber: this.formPersonalAddress.controls.numberAddress.value,
        addressComplement: this.formPersonalAddress.controls.complementAddress.value,
        neighborhood: this.formPersonalAddress.controls.neighborhood.value,
        city: this.formPersonalAddress.controls.cityAddress.value,
        state: this.formPersonalAddress.controls.uf.value,
        country: this.formPersonalAddress.controls.country.value,
        id: this.favorite.id,
        uuid: this.favorite.uuid,
      };

      if (this.favorite.id !== undefined) {
        this.accountPaymentFavoriteService
          .updateFavorite(prepare)
          .pipe(
            tap((data) => {
              if (data.status) {
                this.getAllFavorites();
              }
            }),
            catchError((_) => {
              return of(null);
            })
          )
          .subscribe();
      }
    } else {
      let prepare: AccountPaymentFavoriteDTO;

      prepare = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        name: this.billetChargingForm.controls.nameComplete.value,
        document: this.billetChargingForm.controls.document.value,
        email: this.billetChargingForm.controls.email.value,
        codeBank: '',
        bankName: '',
        accountNumber: '',
        agencyNumber: '',
        typeAccount: '',
        zipCode: this.formPersonalAddress.controls.postalCode.value,
        address: this.formPersonalAddress.controls.address.value,
        addressNumber: this.formPersonalAddress.controls.numberAddress.value,
        addressComplement: this.formPersonalAddress.controls.complementAddress.value,
        neighborhood: this.formPersonalAddress.controls.neighborhood.value,
        city: this.formPersonalAddress.controls.cityAddress.value,
        state: this.formPersonalAddress.controls.uf.value,
        country: this.formPersonalAddress.controls.country.value,
        type: TypeEnum.BILLET,
      };

      this.accountPaymentFavoriteService
        .saveFavorite(prepare)
        .pipe(
          tap((data) => {
            if (data.status) {
              this.resetForms();
              this.getAllFavorites();

              this.drawerData = data;
            }
          }),
          catchError((_) => {
            return of(null);
          })
        )
        .subscribe();
    }
  }

  nextPage() {
   // console.log('-- nextPage');
    if (this.isCreatingFavorite) {
      this.saveFavorite()
    }

    const drawerData = {
      name: this.billetChargingForm.controls.nameComplete.value,
      document: this.billetChargingForm.controls.document.value,
      email: this.billetChargingForm.controls.email.value,
      zipCode: this.formPersonalAddress.controls.postalCode.value,
      street: this.formPersonalAddress.controls.address.value,
      streetNumber: this.formPersonalAddress.controls.numberAddress.value,
      streetComplement: this.formPersonalAddress.controls.complementAddress.value,
      city: this.formPersonalAddress.controls.cityAddress.value,
      neighborhood: this.formPersonalAddress.controls.neighborhood.value,
      state: this.formPersonalAddress.controls.uf.value,
    }
    //console.log('drawerData: ',drawerData)

    this.navCtrl.navigateRoot("/app/charging/billet/v2/emit-detailed", {
      queryParams: {
        drawerData
      }
    });
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }

  async presentPopover(ev: any) {
   // console.log('presentPopover')
    const popover = await this.popoverController.create({
      component: PopoverFavoritesComponent,
      cssClass: 'popover-class',
      event: ev.event,
      translucent: true,
      mode: 'md',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 'exclude') {
        this.deleteFavorite(ev.favorite);
      }
      if (data.data == 'edit') {
        this.storage.set('favoriteForEdit', ev.favorite).then(() => {
          this.storage.set('favoriteType', 'BILLET');
          this.switchFavorites = 'new';
          this.router.navigate(['/app/charging/favorites/charging']);
        });
      }
    });
    return await popover.present();
  }

}
